const getters = {
  token: state => state.user.token,
  name: state => state.user.name,
  btnLimit: state => state.user.btnLimit,
  limit: state => state.user.limit
}
export default getters
